/*
 * @Author: your name
 * @Date: 2021-08-02 14:49:17
 * @LastEditTime: 2021-08-02 15:50:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /qidian-stellaris/src/page/contact-selector-pro/js/utils/kftxt.js
 */
import cookie from '@/common/contact-selector/utils/cookie';

function getCurrentId() {
    if (cookie.get('aid')) {
        return cookie.get('aid');
    }
    const pUin = cookie.get('p_uin');
    return pUin ? pUin.replace(/^o?0*/g, '') : '';
}

export default { getCurrentId };
